import React, {Component} from 'react';
import './SuccessComponent.less';
import {ButtonPrimary} from '@homeaway/react-buttons';

class SuccessComponent extends Component {
    constructor(props) {
        super(props);
        this.close = this.close.bind(this);
    }

    close() {
        this.props.onClose();
    }

    getHeader() {
        let header;
        switch (this.props.successContext) {
            case 'passwordchange':
                header = this.props.lingua.read('lex.header.success.simple');
                break;
            case 'success':
                header = this.props.lingua.read('lex.header.confirmed.account');
                break;
            default:
                let options = {'firstName': this.props.firstName};
                header = this.props.lingua.read('lex.header.success', options);
                break;
        }
        return header;
    }

    getTitle() {
        let title;
        switch (this.props.successContext) {
            case 'passwordchange':
                title = this.props.lingua.read('lex.password.change.success');
                break;
            case 'success':
                title = this.props.lingua.read('lex.account.confirm.title');
                break;
            default:
                title = this.props.lingua.read('lex.signup.success.subtitle');
                break;
        }
        return title;
    }

    render() {
        let header = this.getHeader();
        let title = this.getTitle();
        return (
            <div className="SuccessComponent text-center">
                <div className="SvgImage">
                    <svg width="72" height="72" xmlns="http://www.w3.org/2000/svg">
                        <g stroke="#0067DB" fill="none" fillRule="evenodd">
                            <circle strokeOpacity=".2" cx="36" cy="36" r="35.5"/>
                            <path strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M24 38l10 8 14-20"/>
                        </g>
                    </svg>
                </div>
                <div><h3 className="Header" >{header}</h3></div>
                <p className="SuccessPadding lead">{title}</p>
                <div className="SuccessButton">
                    <form>
                        <ButtonPrimary label={this.props.successContext === 'success' ? this.props.lingua.read('lex.account.confirm.button') : this.props.lingua.read('button.continue')} onClick={this.close} />
                    </form>
                </div>
            </div>
        );
    }
}

export default SuccessComponent;
